var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"•"}},[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.organizationData.name))]),_vm._l((_vm.items),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }